export default {"src":"/evde-internet/_next/static/media/modem-yeni-banner.febd00b7.svg","height":256,"width":1280};